.cd{flex-shrink:0;}